export default __webpack_public_path__ + "static/media/hm-pp-img.7c66ad22.webp";